var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('file-table',{attrs:{"path":_vm.path,"entries":_vm.entries,"is-loading":_vm.isLoadingFiles,"loading-path":_vm.loadingPath,"has-more":_vm.hasShowMore,"commits":_vm.commits},on:{"show-more":_vm.handleShowMore,"row-appear":_vm.handleRowAppear}}),_vm._v(" "),(_vm.readme)?_c('file-preview',{attrs:{"blob":_vm.readme}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }